import { GridColumnVisibilityModel } from "@mui/x-data-grid";
import { atom } from "jotai";

export const GridColumnVisibility = atom<GridColumnVisibilityModel>({});
